import {getFirestore} from 'firebase/firestore'
import {initializeApp} from 'firebase/app'
import {getAuth} from 'firebase/auth'
import {LocalSettingManager} from "biewangle";


const newFirebaseConfig = {
  apiKey: 'AIzaSyCtvQ3d-HAtHTUg_-505c-qXRnlz8RlZeg',
  authDomain: 'aaden-saas.firebaseapp.com',
  projectId: 'aaden-saas',
  storageBucket: 'aaden-saas.appspot.com',
  messagingSenderId: '169167876904',
  appId: '1:169167876904:web:b83934e5a34d1cbfcc161d',
  measurementId: 'G-QRPH7NLDZS',
}


export const firebaseApp = initializeApp(newFirebaseConfig, 'firebaseApp')

export const FireBaseAuth = getAuth(firebaseApp)


export const db = getFirestore(firebaseApp)

export const Remember = LocalSettingManager.config({
  orderId: "",
  takeawayMode: 1,
  sessionId: "",
  modeSelected: 0,
})
